import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function SelectedMenu({
                     label,
                     icon,
                     danger,
                 }: {
    label: string;
    icon: React.ReactNode;
    danger?: boolean;
}) {
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
            }}
        >
            <Typography sx={{ fontSize: 13, color: danger ? "error.main" : "text.primary" }}>
                {label}
            </Typography>

            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: danger ? "error.main" : "text.secondary",
                }}
            >
                {icon}
            </Box>
        </Box>
    );
}